import { SET_LOADING, CLEAR_LOADING } from './loadingActionTypes';

export const setLoading = () => ({
    type: SET_LOADING,
});

export const clearLoading = () => ({
    type: CLEAR_LOADING,
});